import {BehaviorSubject, combineLatest} from 'rxjs';
import {filter, map, startWith} from 'rxjs/operators';
import {spots$} from './spot';
import {currencies$} from './currency';

export const isActivateMarginAccount$ = new BehaviorSubject(false);

export const marginRiskLevels$ = new BehaviorSubject(null);
export const marginCollaterals$ = new BehaviorSubject([]);
export const marginCurrencies$ = combineLatest([marginCollaterals$, currencies$]).pipe(
  map(([marginTradeCollaterals, currencies]) => {
    return marginTradeCollaterals
      .map((o) => {
        const currencyInfo = currencies.find((item) => item.currency === o.currency);
        if (!currencyInfo) {
          return null;
        }
        return {
          ...o,
          name: currencyInfo.name,
          displayCurrency: currencyInfo.displayCurrency,
          valuePrecision: currencyInfo.valuePrecision,
          status: currencyInfo.status,
          valueScale: 0,
          valueFactor: 1,
        };
      })
      .filter(Boolean);
  }),
  startWith([])
);

export const marginCurrencyMap$ = marginCurrencies$.pipe(
  map((currencies) => {
    return currencies.reduce((p, currencyInfo) => {
      p[currencyInfo.currency] = currencyInfo;
      return p;
    }, new Map());
  })
);

export const marginPairs$ = spots$.pipe(map((spots) => spots.filter((item) => item.canMarginTrade)));
export const marginOptions$ = marginPairs$.pipe(map((items) => items.map((item) => ({value: item.symbol, text: item.displaySymbol}))));
export const marginBorrowOptions$ = marginCurrencies$.pipe(map((items) => items.filter((item) => item.canBorrow).map((item) => ({value: item.currency, text: item.currency, name: item.name}))));
export const marginRepayOptions$ = marginCurrencies$.pipe(map((items) => items.filter((item) => item.canRepay).map((item) => ({value: item.currency, text: item.currency, name: item.name}))));
export const marginTransferInOptions$ = marginCurrencies$.pipe(map((items) => items.filter((item) => item.canTransferIn).map((item) => ({value: item.currency, text: item.currency}))));
export const marginTransferOutOptions$ = marginCurrencies$.pipe(map((items) => items.filter((item) => item.canTransferOut).map((item) => ({value: item.currency, text: item.currency}))));
export const marginCurrenciesOptions$ = marginCurrencies$.pipe(map((items) => items.map((item) => ({value: item.currency, text: item.currency}))));
export const crossLeverage$ = marginPairs$.pipe(
  map((marginTradings) => marginTradings && marginTradings[0] && marginTradings[0].leverage),
  filter(Boolean),
  startWith(5)
);
